import script from "./CreateSubmissionView.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSubmissionView.vue?vue&type=script&setup=true&lang=js"

import "./CreateSubmissionView.vue?vue&type=style&index=0&id=652dd994&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-652dd994"]])

export default __exports__